<script lang="ts">
  import { onMount } from 'svelte';
  import { initAuth, authState } from './lib/auth';
  import { route } from './lib/stores';
  import Nav from './components/Nav.svelte';
  import AuthGate from './components/AuthGate.svelte';
  import Home from './components/Home.svelte';
  import TreeView from './components/TreeView.svelte';
  import Admin from './components/Admin.svelte';
  import AuditView from './components/AuditView.svelte';

  onMount(() => { initAuth(); });
</script>

<Nav />

<AuthGate>
  {#if $route.name === 'home'}
    <Home />
  {:else if $route.name === 'tree'}
    {#key $route.treeId}
      <TreeView treeId={$route.treeId} personId={$route.personId} />
    {/key}
  {:else if $route.name === 'admin' && $authState.status === 'admin'}
    <Admin />
  {:else if $route.name === 'audit'}
    <AuditView treeId={$route.treeId} />
  {:else}
    <div class="wrap muted">Not found.</div>
  {/if}
</AuthGate>

<style>
  .wrap { max-width: 760px; margin: 60px auto; padding: 0 18px; }
</style>
